import type { UpdateState } from '../lib/updates';

/**
 * Update signalling.
 *
 * A new generation is offered, never imposed. Replacing the text under someone who is
 * mid-sentence is worse than a slightly stale page, so refreshing is their decision.
 */
export function UpdateBanner({ state, onRefresh }: { state: UpdateState; onRefresh: () => void }) {
  if (state.availableGenerationId) {
    return (
      <div className="update-banner banner-info" role="status">
        <span>
          <strong>New revision available:</strong> a newer generation of this content has been published.
        </span>
        <button type="button" className="banner-action" onClick={onRefresh}>
          Refresh
        </button>
      </div>
    );
  }
  if (state.status === 'updating') {
    return (
      <div className="update-banner banner-warning" role="status">
        <span>
          <strong>Updating:</strong> synchronising the latest committed revision…
        </span>
        <span className="spinner" aria-hidden="true" />
      </div>
    );
  }
  if (state.status === 'stale' || state.status === 'unavailable') {
    return (
      <div className="update-banner banner-error" role="status">
        <span>
          <strong>{state.status === 'stale' ? 'Stale content:' : 'No content generation:'}</strong>{' '}
          {state.status === 'stale'
            ? 'the last synchronisation failed. Showing the last known good generation.'
            : 'no validated generation is active yet.'}
        </span>
      </div>
    );
  }
  return null;
}
